<template>
  <div class="customInputGroup">
    <v-text-field :value="value"
                  :type="type"
                  :placeholder="placeholder"
                  :tooltip="tooltip"
                  :prefix="prefix"
                  :maxlength="maxlength"
                  class="customFormInput"
                  v-bind="$attrs"
                  v-on ="$listeners"
                  @input="onInput($event)"
                  @keypress="checkPositive($event)">
      <template slot="label">
        {{label}}

        <span
          v-if="labelCaption"
          :class="$label.caption"
        >
          {{ labelCaption }}
        </span>

        <app-tooltip v-if="tooltip"
                     :centered="tooltipCentered"
                     :class="$style.tooltip">
          <template v-slot:tooltipHeader>
            <slot name="tooltipHeader" />
          </template>
          <template v-slot:tooltipText>
            <slot name="tooltipText" />
          </template>
        </app-tooltip>

      </template>
    </v-text-field>

  </div>
</template>

<script>

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    label: {
      type: String,
      required: true,
    },
    labelCaption: {
      type: [String, undefined],
      default: undefined,
    },
    placeholder: {
      type: String,
      default: '',
    },
    tooltip: {
      type: Boolean,
      default: false,
    },
    prefix: {
      type: String,
      default: '',
    },
    maxlength: {
      type: [Number, undefined],
      default: undefined,
    },
    tooltipCentered: {
      type: Boolean,
      default: false,
    },
    onlyPositive: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onInput(e) {
      this.$emit('input', e);
    },
    checkPositive(e) {
      if (this.onlyPositive && e.keyCode === 45) {
        e.preventDefault();
      }
    },
  },
};
</script>

<style lang="scss" module>
.tooltip {
  white-space: normal;
}
</style>

<style lang="scss">
@import "@/styles/variables.scss";

.customInputGroup {

  .customFormInput {

    color: $table-data-color;

    &.primary--text {
      /* Overriding Vuetify styles */
      color: $table-data-color !important;
      caret-color: $table-data-color !important;
    }

    .v-text-field__details {
      display: none;
    }

    &.v-text-field >.v-input__control>.v-input__slot {

      .v-text-field__slot {

        display: block;

        label.v-label,
        label.v-label--active {
          display: inline-block;
          /* Overriding Vuetify styles */
          position: relative !important;
          left: 0 !important;
          color: $main-text-color !important;
          font-family: $title-font;
          font-size: 1.6rem;
          line-height: 2.1rem;
          font-weight: 700;
          font-style: italic;
          height: auto;
          margin-bottom: 12px;
          transform: none;
          pointer-events: auto;
          overflow: visible;

          span {
            white-space: normal;
          }
        }

        input {
          border:1px solid $field-borders-color;
          border-radius: 2px;
          max-height: none;
          padding: 9px 10px;

          &:disabled {
            border: $disabled-field-border;
            color: $disabled-field-color;
            background-color: $disabled-field-bg-color;
          }
        }

        .v-text-field__prefix {
          position: absolute;
          top: auto;
          bottom: 17px;
          left: 0;
          width: 38px;
          height: 38px;
          background-color: $field-borders-color;
          text-align: center;
          line-height: 40px;
          font-family: $title-font;

          & + input {
            padding-left: 46px;
          }
        }
      }

      &::before,
      &::after {
        content: none;
      }
    }
  }
}
</style>

<style lang="scss" module="$label">
.caption {
  font-weight: 400;
  font-style: normal;
}
</style>
